import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

function Select({ name, value, label, onChange, onBlur, error, className = 'uk-margin', options, disabled, 'aria-required': ariaRequired, ariaLabel, id }) {
    const innerOnChange = useCallback(({ target: { name, value } }) => onChange({ name, value }), [onChange]);

    if (_.isEmpty(options)) {
        return null;
    }
    return (
        <div className={className}>
            {label && <label for={`${name}`} className="uk-form-label">{label}</label>}
            <select
                id={`${name}`}
                aria-label={ariaLabel ?? name}
                className="uk-select uk-form-controls"
                name={name}
                value={value}
                onChange={innerOnChange}
                onBlur={onBlur}
                disabled={disabled}
                aria-required={ariaRequired}
            >
                {options.map(option => {
                    const label = option.label ?? option;
                    return (
                        <option aria-label={label} key={label} value={option.value}>
                            {label}
                        </option>
                    );
                })}
            </select>
            {error && <div className="uk-text-danger">{error}</div>}
        </div>
    );
}

Select.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    'aria-required': PropTypes.bool,
    ariaLabel: PropTypes.string,
    id: PropTypes.string,
};

export default Select;
